







































import { getCompanyMeasure } from '@/services/api';
import { isEnableAuth } from '@/utils/experiment';
import { getCompanyInfo } from '@/utils/getCompanyInfo';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component({})
export default class ABTestDisplayTableItemDialog extends Vue {

  @Prop()
  visible!:boolean;

  @Watch('visible')
  resetLastMeasure() {
    if (this.visible) {
      this.lastSelectedColumn = JSON.parse(JSON.stringify(this.selectedColumn))
    } else {
      this.selectedColumn = JSON.parse(JSON.stringify(this.lastSelectedColumn))
    }
  }

  get enableAuth() {
    return isEnableAuth();
  }

  get columnsMap(): any {
    return {
      'viewCnt': this.$t('views.wheeloffortune.abtest.text_66dd514975286237') as string,
      'signupCnt': this.$t('views.wheeloffortune.abtest.text_63d04ea475286237') as string,
      'signupRate': this.$t('views.wheeloffortune.abtest.text_63d04ea48f6c5316') as string,
      'orderRate': this.$t('views.wheeloffortune.abtest.text_4e0b53558f6c5316') as string,

      'phoneCnt': this.$t('views.wheeloffortune.abtest.text_653696c6624b673a') as string,
      'viewRate': this.$t('views.wheeloffortune.abtest.text_66dd51497387') as string,
      'orderCnt': this.$t('views.wheeloffortune.abtest.text_4e0b53556570') as string,

      ...(this.enableAuth ? {
        'loginEmailCnt': this.$t('views.wheeloffortune.abtest.text_7b2c4e0965b9767b') as string,
        'loginSignUpCnt': this.$t('views.wheeloffortune.abtest.displaytable.tip-login-submit-count') as string
      } : {}),
    };
  }

  public selectedColumn:string[] = []
  public lastSelectedColumn = []

  public tableColumnsList: string[] = []
  public selectColumnsList = this.enableAuth
    ? ['viewCnt', 'loginEmailCnt', 'signupCnt', 'loginSignUpCnt', 'signupRate', 'orderRate']
    : ['viewCnt', 'signupCnt', 'signupRate', 'orderRate'];

  mounted() {
    // TODO: 需后端修改
    // TODO: 获取当前abtest的measure
    getCompanyMeasure({
      measureCategory: "FORMABTEST"
    }, true).then((res:any) => {
      let measures = res.data.data.measures;
      if(measures?.length){
        this.selectedColumn = measures
        this.tableColumnsList = measures
      }else{
        this.selectedColumn = this.tableColumnsList = ['viewCnt', 'signupCnt', 'signupRate', 'orderRate'];
      }
    })
  }

  close() {
    this.selectedColumn = this.tableColumnsList
    this.$emit('update:visible', false);
  }

  sureDataShowVisible() {
    this.$emit('changeMeasure', this.selectedColumn);
    setTimeout(() => {
      getCompanyMeasure({
        measureCategory: "FORMABTEST"
      }, true).then((res:any) => {
        let measures = res.data.data.measures;
        if(measures?.length){
          this.selectedColumn = measures
          this.tableColumnsList = measures
        }else{
          this.selectedColumn = this.tableColumnsList = ['viewCnt', 'signupCnt', 'signupRate', 'orderRate'];
        }
      })
    }, 2000);
  }

}

